function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group 5");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "website",
  transform: "translate(-1.000000, -3.000000)",
  fill: "#3B3A42"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(1.000000, 3.000000)"
}, React.createElement("path", {
  d: "M24.7679,2.5228 L23.4559,1.1838 C22.3809,0.2928 21.1149,-0.0812 19.7959,0.0148 C18.5989,0.0738 17.4209,0.5318 16.5289,1.4078 L12.9759,4.9008 C13.5919,5.0828 14.1679,5.3598 14.6969,5.7198 L17.8319,2.7118 C18.4249,2.1218 19.2039,1.8038 19.9939,1.7548 C20.7719,1.7388 21.5539,2.0008 22.1519,2.5418 L23.0949,3.4388 C23.6459,3.9808 23.9479,4.6588 24.0299,5.3558 C24.0289,5.3648 24.0299,5.3738 24.0279,5.3828 L24.0329,5.3838 C24.1389,6.3598 23.8039,7.3718 22.9999,8.1098 L17.0589,13.8408 C15.8929,14.9868 13.9549,15.0238 12.7579,13.9398 L11.8149,13.0418 C10.7889,12.0338 10.5479,10.5168 11.2129,9.2648 C11.3369,9.0308 11.6899,8.5948 11.9849,8.2678 C11.4529,7.8058 10.8319,7.9968 10.3539,8.2368 C9.5479,8.6418 9.1149,9.3768 9.0239,10.2738 C8.8779,11.7158 9.3849,13.1858 10.4959,14.2778 L11.4649,15.1998 C12.4139,16.0598 13.6369,16.4848 14.8569,16.4848 C16.1429,16.4848 17.4249,16.0118 18.3809,15.0738 L21.7509,11.7878 L24.2979,9.3658 C25.7939,7.8318 25.9999,6.7098 25.9999,5.3738 C25.9479,3.9858 25.5069,3.3948 24.7679,2.5228",
  id: "Fill-1"
}), React.createElement("path", {
  d: "M11.2894,16.2108 L8.0644,19.3568 C6.8994,20.5008 4.9614,20.5388 3.7644,19.4538 L2.8214,18.5578 C1.4934,17.2498 1.5304,15.1598 2.9184,13.8848 L8.8384,8.2278 C10.0434,7.0268 12.0184,6.9408 13.2874,7.9878 L14.6974,9.3248 C15.9154,10.7388 15.3214,12.2758 13.9624,13.6578 C14.2364,13.7768 14.5374,13.8118 14.8484,13.8468 C16.0974,13.9898 16.7134,12.6808 16.7654,12.4828 C16.8944,12.1028 17.7364,10.0108 15.8444,7.9298 L14.5494,6.7018 C12.4854,4.9918 9.3884,5.1278 7.5124,6.9988 L1.6184,12.6308 C-0.4906,14.5678 -0.5476,17.7758 1.5024,19.7938 L2.4714,20.7138 C3.4194,21.5728 4.6434,21.9998 5.8644,21.9998 C7.1494,21.9998 8.4324,21.5268 9.3874,20.5888 L12.9914,17.0708 C12.3824,16.8768 11.8084,16.5898 11.2894,16.2108",
  id: "Fill-3"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "26px",
    height: "22px",
    viewBox: "0 0 26 22",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/website.3ee567b3.svg";
export { SvgComponent as ReactComponent };